import styled from '@emotion/styled';

export const Icon = styled('div')`
  font-size: 48px;
  color: #B71C1C;
`;

export const Footer = styled('div')`
  display: flex;
  flex-direction: column;
  margin: 4px 0 0 36px;
`;
